import { render } from "./Referral.vue?vue&type=template&id=4f54c283"
import script from "./Referral.vue?vue&type=script&lang=js"
export * from "./Referral.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__